import { render, staticRenderFns } from "./answer.vue?vue&type=template&id=b7b3ff4e&scoped=true&"
import script from "./answer.vue?vue&type=script&lang=js&"
export * from "./answer.vue?vue&type=script&lang=js&"
import style0 from "./answer.vue?vue&type=style&index=0&id=b7b3ff4e&lang=less&scoped=true&"
import style1 from "./answer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b3ff4e",
  null
  
)

export default component.exports